// Replace this with data from your auth/session or API layer.
export const student = {
  name: 'Mr. Udoy Roy Debasish',
  program: 'B. Sc. (Engg.) in Computer Science and Engineering (CSE)',
  studentId: '221-115-001',
  batch: '56',
  section: 'A',
  academicYear: 'Spring 2022',
  admissionDate: '2021-11-08',
  dateOfBirth: '2001-10-20',
  gender: 'Male',
  bloodGroup: 'O+',
  nationality: 'Bangladeshi',
  mobile: '01608623917',
  guardianMobile: '01770124111',
  avatarUrl: '',
};

export const stats = [
  { key: 'courses', label: 'Enrolled Courses', value: 0 },
  { key: 'events', label: 'Upcoming Academic Events', value: 0 },
  { key: 'messages', label: 'Unread Messages', value: 0 },
];
